<template>
  <div>
    <div class="enter_innovation_wrap">
      <div class="enter_img">
        <div class="img_tit hidden-xs-only">公司 + 联盟</div>
        <div class="img_tit hidden-sm-and-up">公司 + 联盟</div>
      </div>
    </div>
    <div class="warp">
      <div class="procard_wrap">
        <div class="procard_btn">
          <div
            class="procard_item"
            v-for="(item, index) in procardList"
            :key="index"
            :class="activeIndex === index ? 'active' : ''"
            @click="changeIndex(index)"
          >
            {{ item.tit }}
          </div>
        </div>
        <div class="procard_content" v-if="activeIndex === 0">
          <div class="content_left">
            <img src="@/assets/img/company.png" alt="" />
          </div>
          <div class="content_right">
            <div class="item">
              <i class="el-icon-caret-right"></i>
              股东单位：约10家（清华研究院（深根科创）、嘉化氢储、浙江氢能、嘉兴燃气等，工商办理中）
            </div>
            <div class="item">
              <i class="el-icon-caret-right"></i
              >董事长/总经理：浙江清华长三角研究委派并提名
            </div>
            <div class="item">
              <i class="el-icon-caret-right"></i
              >运营管理：浙江清华长三角研究院受托管理
            </div>
          </div>
        </div>
        <div class="procard_content" v-else>
          <div class="content_left">
            <div class="wordCloud" ref="wordCloud"></div>
          </div>
          <div class="content_right">
            <div class="item1">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联盟前身为长三角（浙江）
                氢能产业技术联盟（国内第3家）
                2019年7月由浙江清华长三角研究院发起组建
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;成员80余家 ，
                涉及制氢、储运、关键核心零部件、加氢站建设、整车 制造等各个环节
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-wordcloud";
export default {
  data() {
    return {
      activeIndex: 0,
      disableTips: true,
      procardList: [
        {
          tit: "公司主体",
        },
        {
          tit: "联盟组织",
        },
      ],
      wordCloud: null,
    };
  },
  mounted() {
    window.addEventListener("resize", () => this.resize(), false);
  },
  methods: {
    resize() {
      if (this.wordCloud) {
        this.wordCloud.resize();
      }
    },
    changeIndex(index) {
      this.activeIndex = index;
      if (index == 1) {
        this.initPie();
      }
    },
    initPie() {
      if (this.wordCloud) {
        this.wordCloud.dispose();
      }
      this.$nextTick(() => {
        // 获取dom实例，初始化barChart的echarts实例
        if (this.wordCloud) {
          this.wordCloud.dispose();
        }
        this.wordCloud = echarts.init(this.$refs.wordCloud);
        //图表加载状态
        this.wordCloud.showLoading();
        //柱状图参数
        let option = {
          //你的代码
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 30,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: "circle",
              // 字体大小范围
              sizeRange: [20, 50],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: "center",
              top: "center",
              right: null,
              bottom: null,
              // 画布宽
              width: "100%",
              // 画布高
              height: "100%",
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = [
                    "#165DFF",
                    "#6aca37",
                    "#05a4b6",
                    "#f93920",
                    "#f0b114",
                  ];
                  return colors[parseInt(Math.random() * colors.length)];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: "#2ac",
                },
              },
              data: [
                {
                  value: 11.7392043070835,
                  name: "中车时代电动",
                },
                {
                  value: 9.23723855786,
                  name: "中化勘探开发公司",
                },
                {
                  value: 7.75434839431,
                  name: "中国电建华电院",
                },
                {
                  value: 11.3865516372,
                  name: "霍尼韦尔（中国）",
                },
                {
                  value: 7.75434839431,
                  name: "浙石油销售公司",
                },
                {
                  value: 5.83541244308,
                  name: "长三角（浙江）",
                },
                {
                  value: 15.83541244308,
                  name: "浙江清华长三角研究院",
                },
                {
                  value: 2.83541244308,
                  name: "空气化工（中国）",
                },
                {
                  value: 5.83541244308,
                  name: "氢能产业技术联盟",
                },
                {
                  value: 10.83541244308,
                  name: "浙江嘉化能源",
                },
                {
                  value: 5.83541244308,
                  name: "英飞腾（中国）",
                },
                {
                  value: 5.83541244308,
                  name: "美锦能源集团",
                },
                {
                  value: 5.83541244308,
                  name: "天能电池集团",
                },
                {
                  value: 5.83541244308,
                  name: "苏州金龙",
                },
              ],
            },
          ],
        };

        //设置仪表参数
        this.wordCloud.setOption(option);
        this.wordCloud.hideLoading();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/rad.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
  }
}
.warp {
  width: 100%;
  display: flex;
  justify-content: center;
}
.procard_wrap {
  margin-top: 60px;
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;

  @media screen and (max-width: 768px) {
    margin-top: 40px;
    width: 95%;
    background: #f7f7f7;
  }
  .procard_btn {
    width: 100%;
    display: flex;
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;
      &::before {
        content: "▲";
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }
  .procard_content {
    width: 100%;
    display: flex;
    padding-top: 30px;
    justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .content_left {
      width: 50%;
      img {
        width: 100%;
      }
      .wordCloud {
        width: 100%;
        height: 400px;
        @media screen and (max-width: 768px) {
          width: 100%;
          height: 300px;
        }
      }
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
    .content_right {
      width: 50%;
      height: 100%;
      @media screen and (max-width: 768px) {
        margin-top: 20px;
        width: 100%;
      }
      .item {
        height: 33%;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        align-items: center;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          font-weight: 600;
        }
      }
      .item1 {
        height: 100%;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>